'use strict';

const Backbone = require('backbone');
const UserModel = require('common/domain/entity/user');

module.exports = Backbone.Model.extend({
    /**
     * Diagram を同時に閲覧している人を保持する Collection
     */
    initialize: function() {
        this.set({_user: new UserModel(this.get('user'))});
    },

    getUser: function() {
        return this.get('_user');
    }
});



// WEBPACK FOOTER //
// ./balus/domain/entity/viewer.js